(function(){
	'use strict';
	angular.module('app.setup')
		.controller('userLoginHistory', userLoginHistory);

	userLoginHistory.$inject = ['$scope', '$timeout', '$uibModal', '$rootScope', '$location', '$filter',
		'tableService', 'leanFilterService', 'manageEmailAlertsService', 'tableRenderService', 'siteService'];

	function userLoginHistory($scope, $timeout, $uibModal, $rootScope, $location, $filter,
			tableService, leanFilterService, manageEmailAlertsService, tableRenderService, siteService) {
		var vm = this;
		var rendererParams = {};
		var reportSettingsName = 'UserLoginHistory';
		var reportSettingsId;
		var userNdx = globalConfig.user.id;

		if (jQuery('.inlineEditDiv').length) {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
		}

		var extraParams = [{}];
		var noPaging = true;
		
		var defaultFilters = [{}];

		function setUrl() {
			var url = 'User/' + userNdx + '/LoginHistory';
			return url;
		}

		var columns = [{
			'id': 'customerName',
			'display': 'Customer',
			'width': 150,
			'sort': false,
			'disabledShowHide': true
		},
		{
			'id': 'loginDateTimeFmt',
			'display': 'Login Date',
			'width': 100,
			'sort': false,
			'disabledShowHide': true
		},
		{
			'id': 'ipAddress',
			'display': 'IP Address',
			'width': 200,
			'sort': false,
			'disabledShowHide': true
		},
		{
			'id': 'deviceType',
			'display': 'Device',
			'width': 200,
			'sort': false,
			'disabledShowHide': true
		}];

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportUrl: setUrl(),
			noPaging: noPaging,
			columns: columns,
			pinnedColumns: [],
			defaultFilters: defaultFilters,
			defaultSort: 'loginDateTime',
			defaultSortDirection: 'desc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			hideFiltersContainer: true,
			hideNoResultsSuggestion: true,
			hasTabs: true,
			setColumnDefaults: true,
			noFactory: true,
			footer: false,
			isGlobalReportSetting:true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
	
		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			var url = setUrl();
			params.url = url;
			return tableService.getData(params, extraParams).then(function (response) {
				formatResponse(response[0]);
				return response;
			});
		}

		function formatResponse(response) {
			if (response && response.length) {
				angular.forEach(response, function (row) {
					row.loginDateTimeFmt = $filter('date')(row.loginDateTime, 'medium');
				});
			}
		}

		init();

		function init() {
			var incomingQParam = $location.search();
			if (incomingQParam && incomingQParam.userNdx) {
				userNdx = incomingQParam.userNdx;
			}
			vm.hasMultipleCustomers = siteService.getCustomersCount() > 1;
			leanFilterService.clearFilters();
			leanFilterService.setMasterFilterList([]);
		}
	};
})();